import appVersion from "./version.json";

export const isDev = process.env.dev;
console.log(`isDev: ${isDev} ${process.env.NODE_ENV}`);

export const apiBaseUrl = isDev
    ? "https://localhost:7164/api/outlook"
    : "https://ttw-email-api.azurewebsites.net/api/outlook";

export const appVersionString = isDev
    ? `${appVersion.major}.${appVersion.minor}.${appVersion.revision}.${appVersion.build}-dev`
    : `${appVersion.major}.${appVersion.minor}.${appVersion.revision}.${appVersion.build}`;